export class AbortError extends Error {
  constructor (message: string) {
    super(message)
    this.name = 'AbortError'
    this.message = message + ''
  }
}
